export const typeService = [
    { id: 1, name: 'Internet' },
    { id: 2, name: 'Food' },
    { id: 3, name: 'Decorate' },
    { id: 4, name: 'Laundry' },
]


// WEBPACK FOOTER //
// ./src/constant/TypeService.js